import { useEffect, useState } from "react";

interface IComboBox {
  suggestions: string[];
  placeholder: string;
  isLoading: boolean;
  value: string;
  setValue: any;
  type?: string;
}

export default function ComboBox({
  suggestions,
  placeholder,
  isLoading,
  value,
  setValue,
  type,
}: IComboBox) {
  const [isSuggestions, setSuggestions] = useState(false);
  let suggestionArray: string[] = Object.values(suggestions);
  const [SuggestionsList, setSuggestionsList] = useState<string[]>(suggestions);
  useEffect(() => {
    let filter = () =>
      suggestionArray.filter((suggestion) => {
        return suggestion
          .toLowerCase()
          .trim()
          .includes(suggestion.toLowerCase().trim());
      });
    setSuggestionsList(filter);
  }, [value]);
  if (isLoading) {
    return <>Загрузка</>;
  }
  return (
    <div className="flex flex-col">
      <input
        required={true}
        type={type}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        value={value}
        onChange={(e) => {
          value = e.target.value;
          setValue(e.target.value);
          setSuggestions(true);
        }}
        placeholder={placeholder}
      />
      {isSuggestions && (
        <ul className="overflow-auto h-32 max-w-md space-y-1 text-black list-inside">
          {SuggestionsList.map((suggestion, index) => {
            return (
              <li
                onClick={() => {
                  setValue(suggestion);
                  setSuggestions(false);
                }}
                className="bg-white hover:bg-gray-300 text-sm"
                key={index}
              >
                {suggestion}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
